/**
 * LogoutConfirmDialog — dialog di conferma logout.
 *
 * Stessa struttura e stilizzazione di SessionTimeoutWarning (Radix Dialog),
 * usato come primitivo condiviso da tutti gli entry-point di logout del
 * gestionale: logo AppSidebar (desktop), logo AppTopBar (mobile),
 * UserMenuDropdown "Esci".
 *
 * Label pulsanti: "Disconnetti" (conferma) / "Annulla".
 */

import * as Dialog from '@radix-ui/react-dialog';

export interface LogoutConfirmDialogProps {
  open: boolean;
  onConfirm: () => void;
  onCancel: () => void;
}

export function LogoutConfirmDialog({
  open,
  onConfirm,
  onCancel,
}: LogoutConfirmDialogProps) {
  return (
    <Dialog.Root open={open} onOpenChange={(o) => !o && onCancel()}>
      <Dialog.Portal>
        <Dialog.Overlay className="fixed inset-0 bg-black/40 z-40" />
        <Dialog.Content
          aria-describedby="logout-confirm-desc"
          className="fixed left-1/2 top-1/2 -translate-x-1/2 -translate-y-1/2 z-50 w-[90vw] max-w-md bg-white rounded-xl shadow-xl p-6 md:p-8 focus:outline-none"
        >
          <Dialog.Title className="font-headline-md text-headline-md text-text-main mb-2">
            Vuoi uscire?
          </Dialog.Title>
          <Dialog.Description
            id="logout-confirm-desc"
            className="font-body-md text-text-secondary mb-6"
          >
            Verrai disconnesso dalla sessione corrente.
          </Dialog.Description>
          <div className="flex gap-3">
            <button
              type="button"
              onClick={onCancel}
              className="flex-1 h-12 rounded-lg border border-border-gray font-body-md font-semibold text-text-main hover:bg-bg-app transition-colors"
            >
              Annulla
            </button>
            <button
              type="button"
              onClick={onConfirm}
              className="flex-1 h-12 rounded-lg bg-primary text-on-primary font-body-md font-bold hover:opacity-90 transition-opacity"
            >
              Disconnetti
            </button>
          </div>
        </Dialog.Content>
      </Dialog.Portal>
    </Dialog.Root>
  );
}
